export default function SimpleVideoThumbnail({ format, imageUrl }) {
  const width = format === 'horizontal' ? 250 : 90;
  const thumbnail = new URL(imageUrl);
  thumbnail.searchParams.set('width', (width * 1.5).toString());

  if (format === 'vertical') {
    return <>
      <div
        style={{
          backgroundImage: `url(${thumbnail.toString() || '/bg-grey.png'})`,
          backgroundRepeat: 'no-repeat',
          backgroundSize: 'cover',
          width: `${width}px`,
          aspectRatio: '9 / 16',
          borderRadius: '5%',
        }}
      ></div>
    </>;
  }

  if (format === 'horizontal') {
    return <div
      style={{
        backgroundImage: `url(${thumbnail.toString() || '/bg-grey.png'})`,
        backgroundRepeat: 'no-repeat',
        backgroundSize: 'cover',
        aspectRatio: '16 / 9',
        width: `${width}px`,
        borderRadius: '5%',
      }}
    ></div>;
  }

  if (format === 'square') {
    return <div
      style={{
        backgroundImage: `url(${thumbnail.toString() || '/bg-grey.png'})`,
        backgroundRepeat: 'no-repeat',
        backgroundSize: 'cover',
        aspectRatio: '1 / 1',
        width: `120px`,
        borderRadius: '5%',
      }}
    ></div>;
  }

  return <span>Unknown format..</span>
}